import React from 'react';
import { cn } from '@/lib/utils';

export function Skeleton({ className }) {
  return (
    <div className={cn("animate-pulse rounded-lg bg-muted", className)} />
  );
}

export function CardSkeleton() {
  return (
    <div className="p-5 rounded-xl border border-border bg-card space-y-3">
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-8 w-24" />
      <Skeleton className="h-1.5 w-full" />
    </div>
  );
}

export function ListItemSkeleton() {
  return (
    <div className="p-4 rounded-xl border border-border bg-card flex items-center gap-4">
      <Skeleton className="w-10 h-10 rounded-lg" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-3 w-48" />
      </div>
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="space-y-4">
      <div className="grid sm:grid-cols-4 gap-4">
        <CardSkeleton /><CardSkeleton /><CardSkeleton /><CardSkeleton />
      </div>
      <ListItemSkeleton />
      <ListItemSkeleton />
      <ListItemSkeleton />
    </div>
  );
}
